export default "__VITE_ASSET__Botfpky___"